const STORAGE_KEY_RECENT_SEARCHES = 'onward_ticket_recent_searches';
const MAX_RECENT_SEARCHES = 5;

export const saveRecentSearch = (from, to, date) => {
  try {
    const searches = getRecentSearches();
    const newSearch = {
      from,
      to,
      date: date.toISOString(),
      timestamp: new Date().toISOString()
    };
    
    // Remove duplicates and add new one at the beginning
    const filtered = searches.filter(s => 
      !(s.from === from && s.to === to && s.date === newSearch.date)
    );
    const updated = [newSearch, ...filtered].slice(0, MAX_RECENT_SEARCHES);
    localStorage.setItem(STORAGE_KEY_RECENT_SEARCHES, JSON.stringify(updated));
    return updated;
  } catch (error) {
    console.error('Error saving recent search:', error);
    return [];
  }
};

export const getRecentSearches = () => {
  try {
    const searches = localStorage.getItem(STORAGE_KEY_RECENT_SEARCHES);
    return searches ? JSON.parse(searches) : [];
  } catch (error) {
    console.error('Error reading recent searches:', error);
    return [];
  }
};

export const clearRecentSearches = () => {
  try {
    localStorage.removeItem(STORAGE_KEY_RECENT_SEARCHES);
    return true;
  } catch (error) {
    console.error('Error clearing recent searches:', error);
    return false;
  }
};

